import { createContext } from 'react';

import { ModalKey } from './types';

interface ModalContextProps {
	openModal: (modalKey: ModalKey, params?: any) => void;
	closeModal: () => void;
	isOpen: boolean;
}

export const ModalContext = createContext<ModalContextProps | undefined>(undefined);
